import type { Card, DrawMode, Move, ScoringSystem } from "./types.ts";

export const DEFAULT_SCORING_SYSTEM: ScoringSystem = "windows-standard";

interface ScoringProfile {
  wasteToTableau: number;
  wasteToFoundation: number;
  tableauToFoundation: number;
  revealTableauCard: number;
  foundationToTableau: number;
  recycleWasteDrawOne: number;
  recycleWasteDrawThree: number;
  recycleWasteDrawThreeFreePasses: number;
}

const SCORING_PROFILES: Record<ScoringSystem, ScoringProfile> = {
  // Windows Solitaire standard scoring:
  // waste->tableau +5, any real card to foundation +10, tableau reveal +5,
  // foundation->tableau -15, redeal penalties by draw mode. Draw-three gets
  // three free stock passes before the smaller penalty applies.
  "windows-standard": {
    wasteToTableau: 5,
    wasteToFoundation: 10,
    tableauToFoundation: 10,
    revealTableauCard: 5,
    foundationToTableau: -15,
    recycleWasteDrawOne: -100,
    recycleWasteDrawThree: -20,
    recycleWasteDrawThreeFreePasses: 3,
  },
};

export function scoreDeltaForMove(
  system: ScoringSystem,
  move: Move,
  moving: Card[],
  revealedTableauCard: boolean,
): number {
  const p = SCORING_PROFILES[system] ?? SCORING_PROFILES[DEFAULT_SCORING_SYSTEM];
  const movingRealCard = moving.some((card) => !card.isJoker);
  let delta = 0;

  if (movingRealCard) {
    if (move.from.kind === "waste" && move.to.kind === "tableau") {
      delta += p.wasteToTableau;
    } else if (move.from.kind === "waste" && move.to.kind === "foundation") {
      delta += p.wasteToFoundation;
    } else if (move.from.kind === "tableau" && move.to.kind === "foundation") {
      delta += p.tableauToFoundation;
    } else if (move.from.kind === "foundation" && move.to.kind === "tableau") {
      delta += p.foundationToTableau;
    }
  }

  if (revealedTableauCard) delta += p.revealTableauCard;
  return delta;
}

export function scoreDeltaForStockRecycle(
  system: ScoringSystem,
  drawMode: DrawMode,
  recycleCount: number,
): number {
  const p = SCORING_PROFILES[system] ?? SCORING_PROFILES[DEFAULT_SCORING_SYSTEM];
  if (drawMode === "one") return p.recycleWasteDrawOne;
  return recycleCount > p.recycleWasteDrawThreeFreePasses
    ? p.recycleWasteDrawThree
    : 0;
}

export function applyScoreDelta(score: number, delta: number): number {
  return Math.max(0, score + delta);
}
